import { useEffect, useState } from "react";

import { Box, Checkbox, Flex, Spinner } from "@chakra-ui/react";

import { BarAndValue } from "common/components/BarAndValue";
import { actions } from "store/portfolio/reducer";
import { useAppDispatch, useAppSelector } from "store/store";

export function EstadoNECStats() {
	const portfolioStats = useAppSelector((state) => state.portfolio.portfolioStats);
	const filterSelection = useAppSelector((state) => state.portfolio.filterSelection);

	const dispatch = useAppDispatch();

	const [checks, setChecks] = useState<string[]>(filterSelection?.indiceNEC || ["NCE4", "NCE3", "NCE2", "NCE1"]);

	const totalValue = Object.values(portfolioStats.data?.nec_indice || {}).reduce((acc, current) => acc + current, 0);

	useEffect(() => {
		if (checks.length !== 4) dispatch(actions.setFilterSelection({ ...filterSelection, indiceNEC: checks }));
		else dispatch(actions.setFilterSelection({ ...filterSelection, indiceNEC: undefined }));
	}, [checks]);

	return (
		<Flex flexDirection="column" gap="1rem">
			{portfolioStats.thunkState !== "FULFILLED" && (
				<Flex height="5rem" justifyContent="center" alignItems="center">
					<Spinner />
				</Flex>
			)}
			{Object.keys(portfolioStats.data?.nec_indice || {}).map((key) => {
				const currentKey = `NCE${key}`;
				return (
					<Box key={currentKey}>
						<Checkbox
							colorScheme="gray"
							defaultChecked={checks.includes(currentKey)}
							onChange={(ev) => {
								const value = ev.target.checked;
								if (value) {
									setChecks((state) => {
										const asSet = new Set(state);
										asSet.add(currentKey as "NCE4" | "NCE3" | "NCE2" | "NCE1");
										return Array.from(asSet);
									});
								} else {
									setChecks((state) => {
										const asSet = new Set(state);
										asSet.delete(currentKey as "NCE4" | "NCE3" | "NCE2" | "NCE1");
										return Array.from(asSet);
									});
								}
							}}
						>
							{currentKey}
						</Checkbox>
						{checks.length > 0 && portfolioStats.data?.nec_indice[key] ? (
							<BarAndValue
								value={portfolioStats.data?.nec_indice[key] || 0}
								totalValue={totalValue}
								label={currentKey}
								colors={{
									NCE4: "red.700",
									NCE1: "green.400",
									NCE2: "yellow.400",
									NCE3: "orange.300",
								}}
							/>
						) : (
							<></>
						)}
					</Box>
				);
			})}
		</Flex>
	);
}
